/**
 * Created by Fra on 02/05/22.
 */

import React from "react";
import DatePicker from 'react-datepicker';

export default class OnlyDatePicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: new Date()
        }
    }

    componentDidMount() {
        this.setState({ value: this.props.value });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
          this.setState({ value: this.props.value })
        }
    }

    render() {

        const ExampleCustomInput = ({ value, onClick }) => (
            <div style={{width: this.props.width || '300px', height: '40px', border: '1px solid black', lineHeight: '40px', paddingLeft: '10px', background: '#ffffff'}} onClick={onClick}>
              {value}
            </div>
        );

        return ( 
            <div style={mainClass}>
                <div>{this.props.name}</div>
                <DatePicker
                    style={inputText}
                    selected={this.state.value}
                    showTimeSelect={false}
                    onChange={date => {
                        this.props.setDate(date);
                    }}
                    customInput={<ExampleCustomInput />}
                />
            </div>
        )
    }
}

const mainClass = {
    padding: '5px',
    zIndex: 600,
}

const inputText = {
    width: '300px',
    padding: '10px'
}